import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Typography } from "@material-ui/core";
import { useIntl } from "react-intl";
import { messages } from "../../../../messages";
import { useTenantImage } from "@ploy-ui/tenants";
import { clsx } from "clsx";
const EmailSentConfirmation = ({ email, onClose, classes }) => {
    const intl = useIntl();
    const carImage = useTenantImage("Car");
    return (_jsxs(Box, { className: classes.slideinContent, children: [_jsxs(Box, { className: classes.emailForm + " " + classes.emailConfirmation, children: [_jsx("img", { src: carImage ?? undefined, className: clsx(classes.icon, classes.iconOfferLetter), alt: "Car" }), _jsx(Typography, { className: classes.emailSubtitle, children: intl.formatMessage(messages.slideinEmailSent, { email }) })] }), _jsx(Button, { variant: "outlined", onClick: onClose, className: clsx(classes.button, classes.buttonEmailOverlay), children: intl.formatMessage(messages.slideinClose) })] }));
};
export default EmailSentConfirmation;
//# sourceMappingURL=EmailSentConfirmation.js.map